import { render, staticRenderFns } from "./UploadFileInputV2.vue?vue&type=template&id=09b56819&"
import script from "./UploadFileInputV2.vue?vue&type=script&lang=ts&"
export * from "./UploadFileInputV2.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFileInputV2.vue?vue&type=style&index=0&id=09b56819&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports